import { render, staticRenderFns } from "./NormalSearchNav285.vue?vue&type=template&id=673b01c6&scoped=true&"
import script from "./NormalSearchNav285.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav285.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b01c6",
  null
  
)

export default component.exports